import React from 'react'
import PropTypes from 'prop-types'

const LightBox = ({close, children}) => {
    const className = "light-box"

    return (
        <div className={className}>
            <div className={"close-icon fontcon-close"} onClick={close}></div>

            <div className="content">
                {children}
            </div>



            <div className="dialog-box__backdrop"></div>

        </div>
    )
}

LightBox.propTypes = {
    name: PropTypes.string,
    close: PropTypes.func,
    children: PropTypes.any
}

LightBox.defaultProps = {
    name: "LightBox"
}


export default LightBox